import { axiosInstance } from "authProvider";
import { API_URL } from "../../constants";

export const getOuts = () => async (): Promise<[]> => {
  return await axiosInstance
    .get(`${API_URL}/api/ins?populate=*`)
    .then(({ data }) => data.data);
};

export const CreateOut = async (data: any): Promise<unknown> => {
  return await axiosInstance
    .post(`${API_URL}/api/outs`, { data: data })
    .then(({ data }) => data);
};

export const updateOut = async (data: any): Promise<unknown> => {
  return await axiosInstance
    .put(`${API_URL}/api/outs/${data.id}`, { data: { is_archive: true } })
    .then((data) => console.log({ data }));
};
